import { apiRequest } from "../api";

export const getNotifications = (query: string | URLSearchParams) =>
  apiRequest(`/notifications?${query.toString()}`, "GET");
export const getNotificationStats = () => apiRequest("/notifications/stats", "GET");
export const getNotificationRecipients = (query: string) =>
  apiRequest(`/users?${query}`, "GET");
export const sendNotification = (payload: unknown) =>
  apiRequest("/notifications/send", "POST", payload);
